module.exports = __webpack_public_path__ + "img/Educated.14dbb1d0.png";